module.exports = __webpack_public_path__ + "img/NatGas_120X35.e2b0fe2d.png";